export function WorktimeEmpty({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="200"
        height="117"
        viewBox="0 0 200 117"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M90 15C90 12.2386 87.7614 10 85 10C82.2386 10 80 12.2386 80 15V23C80 25.7614 82.2386 28 85 28C87.7614 28 90 25.7614 90 23V15Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M35.8423 71.5125C43.3248 75.8856 51.338 76.708 59.8821 73.9798"
          stroke="var(--clr-title)"
          strokeOpacity="0.2"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeDasharray="1 7"
        />
        <path
          opacity="0.9"
          d="M29.653 70.2119C22.8191 67.9102 20.7328 61.9396 24.8689 57.4795C30.1203 61.0042 31.5951 66.1835 29.653 70.2119Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.65"
          d="M29.6529 70.2117C26.1282 75.4631 19.726 75.3554 16.0572 70.6078C20.8048 66.939 25.8043 66.8669 29.6529 70.2117Z"
          fill="var(--clr-general-primary)"
        />
        <path
          d="M120 15C120 12.2386 117.761 10 115 10C112.239 10 110 12.2386 110 15V23C110 25.7614 112.239 28 115 28C117.761 28 120 25.7614 120 23V15Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path
          d="M130 20H70C62.268 20 56 26.268 56 34V100C56 107.732 62.268 114 70 114H130C137.732 114 144 107.732 144 100V34C144 26.268 137.732 20 130 20Z"
          fill="var(--clr-container-bg)"
          stroke="var(--clr-border-grey-100)"
        />
        <path d="M56 48H144" stroke="var(--clr-border-grey-100)" />
        <path d="M92 34H108" stroke="var(--clr-general-primary)" strokeLinecap="round" />
        <path d="M100 26V42" stroke="var(--clr-general-primary)" strokeLinecap="round" />
        <path
          d="M84 76C88 80.6667 92 80.6667 96 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M104 76C108 80.6667 112 80.6667 116 76"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          d="M92 90C97.3333 94 102.667 94 108 90"
          stroke="var(--clr-general-description)"
          strokeLinecap="round"
        />
        <path
          opacity="0.18"
          d="M78.5 88.5C80.1569 88.5 81.5 87.1569 81.5 85.5C81.5 83.8431 80.1569 82.5 78.5 82.5C76.8431 82.5 75.5 83.8431 75.5 85.5C75.5 87.1569 76.8431 88.5 78.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.18"
          d="M118.5 88.5C120.157 88.5 121.5 87.1569 121.5 85.5C121.5 83.8431 120.157 82.5 118.5 82.5C116.843 82.5 115.5 83.8431 115.5 85.5C115.5 87.1569 116.843 88.5 118.5 88.5Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.45"
          d="M169 53L171 58L176 60L171 62L169 67L167 62L162 60L167 58L169 53Z"
          fill="var(--clr-general-primary)"
        />
        <path
          opacity="0.4"
          d="M46.6 6.2C48.0359 6.2 49.2 5.03594 49.2 3.6C49.2 2.16406 48.0359 1 46.6 1C45.1641 1 44 2.16406 44 3.6C44 5.03594 45.1641 6.2 46.6 6.2Z"
          fill="var(--clr-general-primary)"
        />
      </svg>
    </span>
  );
}
